export const TRACK_HUBS = {
    "nvidia-rtx-5090": {
        slug: "nvidia-rtx-5090",
        series: "RTX 5090",
        searchTerm: "5090",
        title: "NVIDIA RTX 5090 Stock Tracker - In Stock Alerts & Price Tracking | StockMaid",
        description: "Track NVIDIA RTX 5090 availability at Best Buy with real-time stock and pricing updates.",
        intro:
            "The RTX 5090 sells out quickly, so speed matters. This page groups active Best Buy listings and keeps a single place to monitor availability changes."
    },
    "nvidia-rtx-5080": {
        slug: "nvidia-rtx-5080",
        series: "RTX 5080",
        searchTerm: "5080",
        title: "NVIDIA RTX 5080 Stock Tracker - In Stock Alerts & Price Tracking | StockMaid",
        description: "Track NVIDIA RTX 5080 availability at Best Buy with live stock updates and pricing.",
        intro:
            "Use this hub to track RTX 5080 listings without jumping between product pages. It updates against Best Buy data and links to each SKU page."
    },
    "nvidia-rtx-5070": {
        slug: "nvidia-rtx-5070",
        series: "RTX 5070",
        searchTerm: "5070",
        title: "NVIDIA RTX 5070 Stock Tracker - In Stock Alerts & Price Tracking | StockMaid",
        description: "Track NVIDIA RTX 5070 availability at Best Buy with real-time stock and price monitoring.",
        intro:
            "This tracker page focuses on RTX 5070 models for buyers who want a lower price point while still monitoring restocks closely."
    },
    "nvidia-rtx-5070-ti": {
        slug: "nvidia-rtx-5070-ti",
        series: "RTX 5070 Ti",
        searchTerm: "5070 ti",
        title: "NVIDIA RTX 5070 Ti Stock Tracker - In Stock Alerts & Price Tracking | StockMaid",
        description: "Track NVIDIA RTX 5070 Ti availability at Best Buy with live inventory and pricing updates.",
        intro:
            "The RTX 5070 Ti hub surfaces active listings and current statuses for this series so you can move quickly when inventory appears."
    },
    "amd-rx-9070": {
        slug: "amd-rx-9070",
        series: "RX 9070",
        searchTerm: "9070",
        title: "AMD Radeon RX 9070 Stock Tracker - In Stock Alerts & Price Tracking | StockMaid",
        description: "Track AMD Radeon RX 9070, RX 9070 XT and RX 9070 GRE availability at Best Buy, Micro Center and Newegg with real-time stock and price updates.",
        intro:
            "This hub covers the whole RX 9070 family - RX 9070, RX 9070 XT and RX 9070 GRE - across Best Buy, Micro Center and Newegg so you can compare prices and catch restocks in one place."
    },
    "amd-rx-9060": {
        slug: "amd-rx-9060",
        series: "RX 9060",
        searchTerm: "9060",
        title: "AMD Radeon RX 9060 XT Stock Tracker - In Stock Alerts & Price Tracking | StockMaid",
        description: "Track AMD Radeon RX 9060 XT availability at Best Buy, Micro Center and Newegg with live stock and pricing updates.",
        intro:
            "The RX 9060 XT is the value pick of this generation and moves fast when it hits MSRP. This hub groups every listing we track and links to each SKU page."
    }
};

export const TRACK_HUB_LIST = Object.values(TRACK_HUBS);
